import { AppType } from "src/app/shared/enums/AppType.enum";

export class InvitedUserUpdateDto {
  public userName: string;
  public firstName: string;
  public lastName: string;
  public password: string;
  public phone:string;
  public countryId:number;
  public appType:AppType;
}
